import React from 'react';
import clsx from 'clsx';
import { createStyles } from './styles';

export interface InCellDivisionBlockProps {
  withBorder?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  maxWidth?: string;
  className?: string;
  children?: React.ReactNode;
}

const InCellDivisionBlock: React.FC<InCellDivisionBlockProps> = (props): JSX.Element => {
  const { children, withBorder = false } = props;
  const classes = createStyles(props);
  return (
    <div className={clsx(classes.inCellDivision, withBorder && classes.withBorder, props.className)}>{children}</div>
  );
};

export default InCellDivisionBlock;
